import React, { useState, useEffect } from 'react';
import './BackgroundProductListing.scss';
import CTAButton from '../UI/CTA/CTAButton/CTAButton';
import Loader from '../UI/Icons/Loader/Loader';
import { BREAKPOINTS } from '../../constants/breakpoints';

const DESKTOP_WIDTH = BREAKPOINTS.large;

/**
 * Renders background product listing (with bg image)
 * @param {string} anchor
 * @param {object} product
 * @param {string} backgroundImageDesktop
 * @param {string} backgroundImageMobile
 * @param {function} addToCart
 * @param {boolean} enablePreorder
 * @param {string} ctaLink
 * @returns {JSX.Element}
 * @constructor
 */
const BackgroundProductListing = ({
  anchor = 'owl-perch',
  product = {},
  backgroundImageDesktop,
  backgroundImageMobile,
  addToCart,
  enablePreorder = false,
  ctaLink,
  disable,
}) => {
  const [isDesktop, setIsDesktop] = useState(null);

  const renderAttributes = (attributes) =>
    attributes.map((attr) => (
      <li key={attr?.attribute} className="c-background-product-listing__card-attribute">
        {attr?.attribute}
      </li>
    ));

  useEffect(() => {
    setIsDesktop(window.innerWidth > DESKTOP_WIDTH);
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleResize = () => {
    setIsDesktop(window.innerWidth > DESKTOP_WIDTH);
  };

  const [fetching, setFetching] = useState(false);

  const properties = {
    quantity: 1,
    id: product?.variants[0]?.id,
  };

  const addAction = async () => {
    setFetching(true);
    await addToCart(properties, product.title)
      .then(() => setFetching(false))
      .catch(() => {
        setFetching(false);
        console.error('Error fetching, please try again');
      });
  };

  return (
    !disable && (
      <>
        {anchor && <a id={anchor} />}
        <div
          className="c-background-product-listing background-color-gray"
          style={{
            backgroundImage: `url(${isDesktop ? backgroundImageDesktop : backgroundImageMobile})`,
          }}
        >
          <div className="c-background-product-listing__inner">
            <div className="c-background-product-listing__card background-color-white">
              <div className="c-background-product-listing__card-inner">
                <div className="c-background-product-listing__card-icon">
                  <img src={product?.icon?.url} alt={product?.icon?.alt} />
                </div>
                <div className="c-background-product-listing__card-title h3-roobert">
                  <a className="color-black" href={product?.url}>
                    <h3>{product?.title}</h3>
                  </a>
                </div>
                <div className="c-background-product-listing__card-attributes body-1">
                  <ul>{renderAttributes(product?.attributes)}</ul>
                </div>
                <div className="c-background-product-listing__add-to-cart">
                  <CTAButton
                    isButton={!enablePreorder}
                    onClick={enablePreorder || !product?.variants[0]?.available ? null : addAction}
                    ariaLabel={
                      product?.variants[0]?.available
                        ? enablePreorder
                          ? 'Talk to Sales'
                          : `Add to Cart–${product?.price}`
                        : 'Sold Out'
                    }
                    type="primary"
                    text={
                      product?.variants[0]?.available ? (
                        fetching ? (
                          <Loader lightMode={true} />
                        ) : (
                          `Add to Cart–${product?.price}`
                        )
                      ) : enablePreorder ? (
                        'Talk to Sales'
                      ) : (
                        'Sold Out'
                      )
                    }
                    additionalClasses="cta"
                    link={ctaLink || ''}
                    disabled={!product?.variants[0]?.available}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  );
};

export default BackgroundProductListing;
